import Vue from 'vue'
import { Input, Menu, Modal, message } from 'ant-design-vue'

Vue.use(Input)
Vue.use(Menu)
Vue.use(Modal)
Vue.prototype.$message = message;
